import { appSelectors } from '@appStore/reducers/app'
import { connectorApi } from 'api/connector/api.ts'
import { ResponsiveButton } from 'components/atoms/responsiveButton'
import { useAppSelector } from 'shared/hooks/store.ts'
import { useStopReloadSession } from 'shared/hooks/useStopReloadSession.ts'

import css from './UserHeaderWidget.module.scss'

export function LogOut() {
	const impersonatedPersona = useAppSelector(appSelectors.isImpersonated)

	const [signOutMember, { isLoading: isLoadingStopSession }] =
		useStopReloadSession()
	const [signOut, { isLoading }] = connectorApi.useSignOutMutation()

	return impersonatedPersona ? (
		<ResponsiveButton
			className={css.logOut}
			disabled={false}
			isLoading={isLoadingStopSession}
			onClick={signOutMember}
		>
			Stop session
		</ResponsiveButton>
	) : (
		<ResponsiveButton
			className={css.logOut}
			isLoading={isLoading}
			onClick={() => signOut()}
		>
			Log Out
		</ResponsiveButton>
	)
}
